import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@app/router/router.module';
import { CoreModule } from '@app/core/core.module';
import { ImageModule } from '@app/image/image.module';
import { AdsDirective } from './directives/ads.directive';
import { B2Component } from './components/b2.component';
import { B2InbodyComponent } from './components/b2-inbody.component';



@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        CoreModule,
        ImageModule,
    ],
    exports: [
        AdsDirective,

    ],
    declarations: [
        AdsDirective,
        B2Component,
        B2InbodyComponent
    ],
})
export class AdsModule { }
